<template lang="pug">
.contratos-container
    .form-scrollbar(v-if='contratos.length > 0')
        el-scrollbar
            el-form(v-for="(contrato, index) in contratos" :key="index" class="contrato-item" :inline="true" label-position="top")
                .form-content-group
                    el-form-item(class="contrato-id mb-0")
                        el-checkbox(v-model="selecionados" :label='contrato.id' class="pr-2") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.contract') }}
                        span.negrito {{ contrato.contractNumber }}
                    .form-content-items
                        el-form-item(class="mb-0 pl-4")
                            span {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.availableVolume') }}
                            span(class="text-green bold") {{ formatters.formatNumber(contrato.avaliableVolume) }} t
                        el-form-item(class="mb-0 pl-5")
                            span {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.contractDate') }}
                            span(class="bold") {{ contrato.contractDateFormatted }}
                        el-form-item(class="mb-0 pl-5 w-45")
                            span {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.district') }}
                            span(class="bold") {{ contrato.receivingLocation }}
                        el-form-item(class="mb-0")
                            el-button(type="text" @click="verContrato(contrato.id)")
                                | {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.contractView') }}
                                i.el-icon-arrow-right
                el-form-item(class="input-volume" :error="getErrorMessage(contrato.id)")
                    .d-flex
                        span {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.volume') }}
                    el-tooltip(
                        :disabled="selecionados.includes(contrato.id)"
                        :content="$t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.selectContract')"
                        placement="top"
                    )
                        el-input(
                            v-model.number="volumes[contrato.id]"
                            :placeholder="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.volume')"
                            type="number"
                            :disabled="!selecionados.includes(contrato.id)"
                            @keydown.native="blockInvalidChars"
                            @input="validateVolume(contrato)"
                        )
    div.mt-3(v-else)
        p {{ this.$t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.noContractFound') }}
    .button-adicionar.mt-3
        BaseButton(type="primary", @click="adicionarLista", :disabled='contratos.length === 0') {{ this.$t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.addButton') }}

    ModalViewContract(
       :mostrar="mostrar",
       :contractId="contractId",
       @fechar="fecharModalViewContract"
    )
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import ModalViewContract from '@/modules/traceability-report/views/components/modal-view-contract/ModalViewContract.vue';
import EventBus from '@/utils/eventBus';
import formatters from '@/utils/formatters';

export default {
    name: 'contract-list',
    props: {
        contratos: {
            type: Array,
            required: true
        },
        reportVolumeAvailable: {
            type: [Number, null],
            required: false
        },
        contratosCarregados: {
            type: Array,
            required: false
        }
    },
    components: { BaseButton, ModalViewContract },
    data() {
        return {
            formatters,
            selecionados: [],
            volumes: {},
            errorMessages: {},
            totalContratos: [],
            contractId: null,
            mostrar: false
        };
    },
    created() {
        EventBus.$on('remover-contratos', contratosExcluidos => {
            this.totalContratos = this.totalContratos.filter(contrato =>
                !contratosExcluidos.some(excluido => excluido.id === contrato.id)
            );
        });
    },
    mounted () {
        if (this.contratosCarregados.length > 0) {
            this.totalContratos = this.contratosCarregados;
        }
    },
    watch: {
        reportVolumeAvailable: {
            handler(newValue) {
                this.selecionados.forEach(id => {
                    const contrato = this.contratos.find(c => c.id === id);
                    if (contrato) {
                        this.validateVolume(contrato);
                    }
                });
            },
            immediate: true
        },
        selecionados: {
            handler(newSelecionados, oldSelecionados) {
                const desmarcados = oldSelecionados.filter(id => !newSelecionados.includes(id));

                desmarcados.forEach(id => {
                    this.$delete(this.errorMessages, id);
                    this.volumes[id] = null;
                });
            },
            deep: true
        }
    },
    computed: {
        hasErrors() {
            return Object.keys(this.errorMessages).length > 0;
        }
    },
    methods: {
        verContrato(id) {
            this.contractId = id;
            this.mostrar = true;
        },
        fecharModalViewContract() {
            this.mostrar = false;
            this.contractId = null;
        },
        blockInvalidChars(event) {
            const allowedKeys = [
                'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'
            ];
            const invalidKeys = ['e', 'E', '-', '+', '.'];

            if (allowedKeys.includes(event.key)) {
                return;
            }

            if (invalidKeys.includes(event.key) || !/^[0-9]$/.test(event.key)) {
                event.preventDefault();
            }
        },
        validateVolume(contrato) {
            if (!contrato || this.volumes[contrato.id] === undefined) {
                return;
            }

            let volume = this.volumes[contrato.id];
            if (volume < 0) {
                this.volumes[contrato.id] = 0;
            }

            const volumeString = volume.toString();
            if (volumeString.length > 11) {
                this.volumes[contrato.id] = parseFloat(volumeString.slice(0, 11));
                volume = this.volumes[contrato.id];
            }

            if (volume > contrato.avaliableVolume) {
                this.$set(this.errorMessages, contrato.id, {
                    message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.availableVolumeError'),
                    contractNumber: contrato.contractNumber
                });
            } else if (!this.reportVolumeAvailable || this.reportVolumeAvailable === 0) {
                this.$set(this.errorMessages, contrato.id, {
                    message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.reportVolumeError'),
                    contractNumber: contrato.contractNumber
                });
            } else {
                this.$delete(this.errorMessages, contrato.id);
            }
        },
        getErrorMessage(id) {
            if (!this.errorMessages[id]) {
                return;
            }
            return this.errorMessages[id].message || '';
        },
        adicionarLista() {
            if (this.hasErrors) {
                let offset = 20;
                Object.keys(this.errorMessages).forEach((id, index) => {
                    const contractNumber = this.errorMessages[id].contractNumber;
                    if (this.reportVolumeAvailable === 0 || !this.reportVolumeAvailable) {
                        this.$notify.error({
                            message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.reportVolumeError'),
                            offset: offset
                        });
                        offset += 70;
                    } else {
                        this.$notify.error({
                            message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.volumeAddError', { contrato: contractNumber }),
                            offset: offset
                        });
                        offset += 70;
                    }
                });
            } else {
                const contratosDuplicados = this.contratos
                    .filter(contrato =>
                        this.selecionados.includes(contrato.id) &&
                        this.totalContratos.some(existingContrato => existingContrato.id === contrato.id)
                    );

                let offset = 100;
                if (contratosDuplicados.length) {
                    this.$notify.error({
                        message: this.$t('relatorio_rastreabilidade.messages.traceabilityReport.contractList.selectContractError'),
                        offset: offset
                    });
                    offset += 70;
                    return;
                }

                const contratosSelecionados = this.contratos
                    .filter(contrato =>
                        this.selecionados.includes(contrato.id) &&
                        this.volumes[contrato.id] &&
                        this.volumes[contrato.id] <= contrato.avaliableVolume
                    )
                    .map(contrato => ({
                        ...contrato,
                        volumeSelecionado: this.volumes[contrato.id]
                    }))
                    .filter(contrato =>
                        !this.totalContratos.some(existingContrato => existingContrato.id === contrato.id)
                    );

                this.totalContratos = [...this.totalContratos, ...contratosSelecionados];

                if (contratosSelecionados.length) {
                    EventBus.$emit('contratos-selecionados', this.totalContratos);
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.form-scrollbar {
    max-height: 400px;
    overflow-y: auto;
}
.contrato-item {
    display: flex;
    margin-bottom: 15px;
    padding: 10px;
    border-bottom: 1px solid #ebeef5;
    background-color: #fff;
}

.form-content-group {
    width: 82%;
}

.form-content-items {
    background: #f5f5f5;
    display: flex;
    justify-content: space-between;
    border-radius: 4px;
}

.el-checkbox__label {
    font-weight: 400 !important;
}

.mb-0 {
    margin-bottom: 0 !important;
}

.input-volume {
    margin-left: 28px;
    width: 15%;
}

.negrito {
    font-weight: 500;
}

.text-green {
    color: #359138;
}

.button-adicionar {
    display: flex;
    justify-content: flex-end;
}

.pl-5 {
    padding-left: 5%;
}

.w-45 {
    width: 45%;
}
.bold {
    font-weight: 600;
}
</style>
